<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Filter By Jurisdictions</h4>

    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onCancel()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <ul class="nav nav-tabs nav-tabs-spaced">
      @if (theJurisdictions[0].length > 0) {
      <li class="panel-tab">
        <a
          [routerLink]=""
          [class]="collection == 'USA' ? 'selected' : 'none'"
          (click)="onCategoryChange('USA')"
        >
          USA
          @if (hasSelectionInCollection('USA')) {
            <mat-icon class="tab-check-icon">check</mat-icon>
          }
        </a>
      </li>

      } @if (theJurisdictions[1].length > 0) {
      <li class="panel-tab">
        <a
          [routerLink]=""
          [class]="collection == 'CAN' ? 'selected' : 'none'"
          (click)="onCategoryChange('CAN')"
        >
          Canada
          @if (hasSelectionInCollection('CAN')) {
            <mat-icon class="tab-check-icon">check</mat-icon>
          }
        </a>
      </li>
      }@if (theJurisdictions[2].length > 0) {
      <li class="panel-tab">
        <a
          [routerLink]=""
          [class]="collection == 'MEX' ? 'selected' : 'none'"
          (click)="onCategoryChange('MEX')"
        >
          Mexico
          @if (hasSelectionInCollection('MEX')) {
            <mat-icon class="tab-check-icon">check</mat-icon>
          }
        </a>
      </li>
      } @if(globalJurisdictions.length > 0) {
      <li class="panel-tab">
        <a
          [routerLink]=""
          [class]="collection == 'Global' ? 'selected' : 'none'"
          (click)="onCategoryChange('Global')"
        >
          International
          @if (hasSelectionInCollection('Global')) {
            <mat-icon class="tab-check-icon">check</mat-icon>
          }
        </a>
      </li>
      }
    </ul>
    <div class="panel-content">
      <div class="buttonbar">
        <button
          mat-button
          class="button-close"
          (click)="selectAllJurisdictions(collection)"
          [disabled]="collection.length === 0"
        >
          Select All
        </button>

        <button
          mat-button
          class="button-close"
          (click)="clearAllJurisdictions(collection)"
          [disabled]="collection.length === 0"
        >
          Clear All
        </button>
      </div>
      <div class="evenly" [class.global-jurisdiction]="collection !== 'USA'">
        @for (item of getSortedJurisdictions(collection); track item) {

        <mat-checkbox
          class="filter-country ml-2"
          mat-button
          [ngModel]="isJurisdictionSelected(item, collection)"
          (ngModelChange)="jurisdictionChanged($event, item, collection)"
          >{{ getDisplayItem(item, collection) }}
        </mat-checkbox>

        }
      </div>
    </div>

    <div mat-dialog-actions class="buttonbar" align="right">
      <div>
        <button
          mat-button
          [disabled]="!hasChanges()"
          (click)="onApply()"
          class="button-close"
          cdkFocusInitial
        >
          Apply
        </button>
        <button
          mat-button
          (click)="onCancel()"
          mat-dialog-close
          class="button-close"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
